// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"m0-z","sponsoredTooltipWrapper":"n0-z","sponsoredTooltip":"o0-z","newCard":"p0-z"};